import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = '/api/lucky-draw'
const QUERY_KEY = 'lucky-draw'

export const useGetLuckyDraws = (config = {}) =>
  useQuery([QUERY_KEY], async () => (await axios.get(ENDPOINT)).data, config)

export const useGetLuckyDrawById = (id, config = {}) =>
  useQuery([QUERY_KEY], async () => (await axios.get(`${ENDPOINT}/${id}`)).data, config)

export const usePostLuckyDraw = (config = {}) =>
  useMutation((newData) => axios.post(ENDPOINT, newData), config)

export const usePostLuckyDrawCompany = (config = {}) =>
  useMutation((newData) => axios.post(`${ENDPOINT}/company`, newData), config)

export const usePatchLuckyDraw = (config = {}) =>
  useMutation((updatedData) => axios.patch(ENDPOINT, updatedData), config)

export const useDeleteLuckyDraw = (config = {}) =>
  useMutation((id) => axios.delete(ENDPOINT, { data: id }), config)

export const useExportLuckyDrawTicket = (config = {}) =>
  useMutation(
    () => axios.get(`${ENDPOINT}/export-lucky-draw-ticket`, { responseType: 'blob' }),
    config
  )

export const useGetTickets = () =>
  useQuery(
    [`${QUERY_KEY}_lucky_draw_tikcet`, 'list'],
    async () => (await axios.get(`${ENDPOINT}/tickets`)).data,
    { staleTime: 1000 * 60 * 24 }
  )

export const usePostWinners = (config = {}) =>
  useMutation((newData) => axios.post(`${ENDPOINT}/winners`, newData), config)
